import { getRequest } from '../services/requestHandler';
import { OrderStatusList } from '../models';

export const getOrderStatusList = async () => {
  const url = `orderLookup/getOrderStatusList?activeOnly=true`;
  const response = await getRequest<OrderStatusList>('getOrderStatusList', url);
  return response;
};
